var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.75H18C18 15.4062 16.6562 16.75 15 16.75C13.3438 16.75 12 15.4062 12 13.75H11H8C8 15.4062 6.65625 16.75 5 16.75C3.34375 16.75 2 15.4062 2 13.75H1C0.4375 13.75 0 13.3125 0 12.75C0 12.2188 0.4375 11.75 1 11.75H2.75C3.3125 11.1562 4.09375 10.75 5 10.75C5.875 10.75 6.6875 11.1562 7.21875 11.75H11V4.75C11 4.21875 11.4375 3.75 12 3.75H12.5H13H14.5625C15.0938 3.75 15.625 3.96875 16 4.34375L18.4062 6.75C18.7812 7.125 19 7.65625 19 8.1875V8.75V9.75V11.75C19.5312 11.75 20 12.2188 20 12.75C20 13.3125 19.5312 13.75 19 13.75ZM13 5.75V8.75H17V8.1875L14.5625 5.75H13ZM6.5 13.75C6.5 12.9375 5.8125 12.25 5 12.25C4.15625 12.25 3.5 12.9375 3.5 13.75C3.5 14.5938 4.15625 15.25 5 15.25C5.8125 15.25 6.5 14.5938 6.5 13.75ZM15 15.25C15.8125 15.25 16.5 14.5938 16.5 13.75C16.5 12.9375 15.8125 12.25 15 12.25C14.1562 12.25 13.5 12.9375 13.5 13.75C13.5 14.5938 14.1562 15.25 15 15.25Z",
    fill: "#E6E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9998 14.75C15.552 14.75 15.9998 14.3023 15.9998 13.75C15.9998 13.1977 15.552 12.75 14.9998 12.75C14.4475 12.75 13.9998 13.1977 13.9998 13.75C13.9998 14.3023 14.4475 14.75 14.9998 14.75ZM14.9998 16.75C16.6566 16.75 17.9998 15.4069 17.9998 13.75C17.9998 12.0931 16.6566 10.75 14.9998 10.75C13.3429 10.75 11.9998 12.0931 11.9998 13.75C11.9998 15.4069 13.3429 16.75 14.9998 16.75Z",
    fill: "url(#paint0_linear_3390_6442)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14.75C5.55228 14.75 6 14.3023 6 13.75C6 13.1977 5.55228 12.75 5 12.75C4.44772 12.75 4 13.1977 4 13.75C4 14.3023 4.44772 14.75 5 14.75ZM5 16.75C6.65685 16.75 8 15.4069 8 13.75C8 12.0931 6.65685 10.75 5 10.75C3.34315 10.75 2 12.0931 2 13.75C2 15.4069 3.34315 16.75 5 16.75Z",
    fill: "url(#paint1_linear_3390_6442)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3390_6442",
    x1: 11.9998,
    y1: 11.35,
    x2: 17.0998,
    y2: 16.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#990219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3677D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3390_6442",
    x1: 2,
    y1: 11.35,
    x2: 7.1,
    y2: 16.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#990219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3677D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTruck);
export default __webpack_public_path__ + "static/media/icon-truck.cf232a4d1acc5d45f48b403f5c3d000f.svg";
export { ForwardRef as ReactComponent };